module.exports = __webpack_public_path__ + "img/home1.c816d4c7.jpg";